import {StyledProPhotoTitleWrapper} from './style'
import {useTranslation} from '@/translations/i18n'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ProPhotosGrid} from '@/features/submission-pro-photos-upload/components/pro-photos-grid/ProPhotosGrid'

interface ProPhotosTitleProps {
    imagesLength: number
    serviceTitle: string
    uploadButton: React.ReactNode
}

export const ProPhotosTitle = ({uploadButton, imagesLength, serviceTitle}: ProPhotosTitleProps) => {
    const {t} = useTranslation()

    return (
        <ProPhotosGrid
            leftSlot={
                <StyledProPhotoTitleWrapper justify="space-between" align="center" fullWidth>
                    <Flexbox gap={2} align="center">
                        <h3>{t('vetting:reordering:gallery')}</h3>
                        {!!imagesLength && <span>{t('vetting:reordering:x_photos', {count: imagesLength})}</span>}
                    </Flexbox>

                    {uploadButton}
                </StyledProPhotoTitleWrapper>
            }
            rightSlot={
                <StyledProPhotoTitleWrapper align="center">
                    <h3>{serviceTitle}</h3>
                </StyledProPhotoTitleWrapper>
            }
        />
    )
}
ProPhotosTitle.displayName = 'ProPhotosTitle'
